import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentStep } from "../../redux/actions";

function DummyCoachMark() {
  const currentStep = useSelector((state) => state.paginationData.currentStep);
  const dispatch = useDispatch();

  const handleNext = () => {
    dispatch(setCurrentStep(currentStep + 1));
  };

  const handleSkipAll = () => {
    dispatch(setCurrentStep(-1)); // Reset Redux state
  };

  if (currentStep !== 1) {
    return null; // Render nothing if currentStep is not 1
  }

  return (
    <div className="popup-container">
      <div className="popup-content">
        <h3>Switching to Sub-Games Tab</h3>
        <p>Switch between tabs to choose your preferred bet type.</p>
        <button onClick={handleSkipAll} className="popup-button">
          Skip All
        </button>
        <button onClick={handleNext} className="popup-button">
          Next
        </button>
      </div>
    </div>
  );
}

export default DummyCoachMark;
